//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CountryChart from '~/components/countryGuides/CountryChart.vue'
import CountryDescription from '~/components/countryGuides/CountryDescription.vue'
import CountryFeatures from '~/components/countryGuides/CountryFeatures.vue'
import CountryPaymentCard from '~/components/countryGuides/CountryPaymentCard.vue'
import CountryTop from '~/components/countryGuides/CountryTop.vue'
import FooterTop from '~/components/footer/footerTop.vue'
export default {
  components: {
    CountryTop,
    CountryPaymentCard,
    CountryDescription,
    CountryFeatures,
    CountryChart,
    FooterTop
  },
  head () {
    return {
      title: this.$t('footer.markets.br').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
